import { APIOrganizationUser, ArdoqId, OrgAccessLevel } from '@ardoq/api-types';

const isActiveSCIMUser = (user: APIOrganizationUser): boolean => user.active;

/**
 * Get all members of the organization including contributors.
 */
const getAllOrgUsers = (users: APIOrganizationUser[]) => {
  return users.filter(isActiveSCIMUser);
};

/**
 * Get all members of the organization except contributors.
 */
const getOrgMembers = (users: APIOrganizationUser[]) => {
  return getAllOrgUsers(users).filter(
    user => user.role !== OrgAccessLevel.CONTRIBUTOR
  );
};

const getOrgAdmins = (users: APIOrganizationUser[]) => {
  return getAllOrgUsers(users).filter(
    user => user.role === OrgAccessLevel.ADMIN
  );
};
const getOrgContributors = (users: APIOrganizationUser[]) => {
  return getAllOrgUsers(users).filter(
    user => user.role === OrgAccessLevel.CONTRIBUTOR
  );
};

const getUserById = (
  usersById: Record<ArdoqId, APIOrganizationUser>,
  userId: string
): APIOrganizationUser | null => {
  return usersById[userId] ?? null;
};

const getUserDisplayText = (user: APIOrganizationUser) => {
  const name = user.name;
  const email = user.email;
  if (name && email) {
    return `${name} (${email})`;
  }
  return email;
};

const formatUserField = (
  usersById: Record<ArdoqId, APIOrganizationUser>,
  val: unknown
): string | null => {
  if (typeof val !== 'string') return null;
  const user = getUserById(usersById, val);
  return user ? getUserDisplayText(user) : null;
};

/**
 * Operations related to users list in the organization.
 */
export const usersOperations = {
  /**
   * Get all members of the organization including contributors.
   */
  getAllOrgUsers,
  /**
   * Get all members of the organization except contributors.
   */
  getOrgMembers,
  getOrgAdmins,
  getOrgContributors,
  getUserById,
  getUserDisplayText,
  formatUserField,
  isActiveSCIMUser,
};
